module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/battle-unique-normal.b67a968c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/battle-unique-normal.png
// module id = 3427
// module chunks = 11